{
  "app.name": "Cargofollow Sign",
  "app.tagline": "Frachtbriefe auf dem Telefon unterschreiben und einsehen.",
  "language.label": "Sprache",
  "language.nl": "Niederländisch",
  "language.en": "Englisch",
  "language.de": "Deutsch",
  "language.fr": "Französisch",
  "home.title": "Cargofollow Sign",
  "home.body": "Diese App öffnen Sie über den Link oder QR-Code, den Sie vom Absender oder Frachtführer erhalten haben. Ohne Link gibt es nichts zu zeigen.",
  "route.sign.title": "Unterschreiben",
  "route.sign.body": "Der Signaturablauf für diesen Link wird hier geladen.",
  "route.inspect.title": "Kontrolle",
  "route.inspect.body": "Der Frachtbrief zu diesem Kontrolllink wird hier angezeigt.",
  "route.driver.title": "Fahrer",
  "route.driver.body": "Ihre Fahrten werden hier angezeigt.",
  "offline.body": "Sie sind offline. Was Sie sehen, stammt aus dem Zwischenspeicher dieser App.",
  "error.title": "Etwas ist schiefgelaufen",
  "error.body": "Versuchen Sie es erneut. Wenn es weiter fehlschlägt, fordern Sie einen neuen Link an.",
  "error.not_found.title": "Seite nicht gefunden",
  "error.not_found.body": "Prüfen Sie den Link oder QR-Code, den Sie erhalten haben.",
  "error.network": "Keine Verbindung zum Server.",
  "error.unexpected": "Unerwarteter Fehler.",
  "loading": "Wird geladen",
  "button.sign": "Unterschreiben",
  "button.clear": "Löschen",
  "button.undo": "Rückgängig",
  "button.confirm": "Bestätigen",
  "button.cancel": "Abbrechen",
  "button.retry": "Erneut versuchen",
  "button.open": "Öffnen",
  "button.view_pdf": "PDF ansehen",
  "status.expired.title": "Link abgelaufen",
  "status.expired.body": "Dieser Signaturlink ist abgelaufen. Bitten Sie den Absender um einen neuen Link.",
  "status.used.title": "Bereits unterschrieben",
  "status.used.body": "Dieser Link wurde bereits verwendet. Es ist nichts weiter zu tun.",
  "status.revoked.title": "Link zurückgezogen",
  "status.revoked.body": "Die Partei, die diesen Link geschickt hat, hat ihn zurückgezogen. Bitten Sie um einen neuen Link.",
  "status.success.title": "Unterschrieben",
  "status.success.body": "Vielen Dank, {name}. Ihre Unterschrift wurde am {timestamp} erfasst.",
  "shipment.title": "Frachtbrief",
  "shipment.reference": "Referenz",
  "shipment.consignor": "Absender",
  "shipment.consignee": "Empfänger",
  "shipment.carrier": "Frachtführer",
  "shipment.pickup": "Ladestelle",
  "shipment.delivery": "Entladestelle",
  "shipment.window": "Zeitfenster",
  "shipment.goods": "Güter",
  "shipment.goods.none": "Noch keine Güter erfasst.",
  "shipment.transport": "Transport",
  "shipment.vehicle": "Kennzeichen",
  "shipment.driver": "Fahrer",
  "shipment.transport_type": "Transportart",
  "shipment.charges": "Kosten",
  "shipment.charges.carriage": "Frachtpreis",
  "shipment.special_agreements": "Besondere Vereinbarungen",
  "shipment.status.draft": "Entwurf",
  "shipment.status.issued": "Ausgestellt",
  "shipment.status.in_transit": "Unterwegs",
  "shipment.status.delivered": "Abgeliefert",
  "shipment.status.completed": "Abgeschlossen",
  "shipment.status.cancelled": "Storniert",
  "shipment.transport_type.national": "National",
  "shipment.transport_type.international": "International",
  "shipment.transport_type.cabotage": "Kabotage",
  "shipment.transport_type.combined": "Kombiniert",
  "package_type.pallet": "Paletten",
  "package_type.box": "Kisten",
  "package_type.carton": "Kartons",
  "package_type.crate": "Verschläge",
  "package_type.bag": "Säcke",
  "package_type.drum": "Fässer",
  "package_type.roll": "Rollen",
  "package_type.bundle": "Bündel",
  "package_type.container": "Container",
  "package_type.loose": "lose",
  "package_type.other": "Packstücke",
  "document.kind.ecmr_pdf": "Frachtbrief",
  "document.kind.pod_pdf": "Ablieferbeleg",
  "document.kind.attachment": "Anlage",
  "document.kind.signature_image": "Unterschrift",
  "document.kind.photo": "Foto",
  "document.kind.other": "Dokument",
  "documents.empty.title": "Keine Dokumente",
  "documents.empty.body": "Sobald ein Frachtbrief oder eine Anlage bereitsteht, erscheint sie hier.",
  "timeline.empty.title": "Noch keine Ereignisse",
  "timeline.empty.body": "Die Historie dieser Sendung füllt sich, sobald etwas passiert.",
  "event.shipment.created": "Sendung angelegt",
  "event.shipment.issued": "Frachtbrief ausgestellt",
  "event.shipment.updated": "Sendung geändert",
  "event.shipment.cancelled": "Sendung storniert",
  "event.shipment.pickup_signed": "Bei der Beladung unterschrieben",
  "event.shipment.delivered": "Abgeliefert",
  "event.shipment.completed": "Sendung abgeschlossen",
  "event.signature.completed": "Unterschrift erfasst",
  "event.document.created": "Dokument hinzugefügt",
  "event.remark.added": "Bemerkung hinzugefügt",
  "event.inspection.viewed": "Kontrolle angesehen",
  "event.provider.sync_failed": "Synchronisation fehlgeschlagen",
  "event.efti.uil_issued": "eFTI-UIL ausgestellt",
  "event.efti.authority_access": "Von einer Behörde abgerufen",
  "event.efti.combined_transport_stamped": "Stempel kombinierter Verkehr",
  "actor.api_key": "API-Schlüssel",
  "actor.user": "Benutzer",
  "actor.signer": "Unterzeichner",
  "actor.provider": "Plattform",
  "actor.system": "System",
  "actor.public": "Öffentlicher Link",
  "actor.authority": "Behörde",
  "signature.hint": "Unterschreiben Sie im Feld.",
  "signature.ready": "Unterschrift erfasst.",
  "sign.role.consignor": "Absender",
  "sign.role.carrier": "Frachtführer",
  "sign.role.consignee": "Empfänger",
  "sign.intro": "Sie unterschreiben diesen Frachtbrief als {role}.",
  "sign.expires": "Dieser Link ist gültig bis {timestamp}.",
  "sign.documents.title": "Dokumente",
  "sign.signatures.title": "Bereits unterschrieben",
  "sign.signatures.none": "Es hat noch niemand unterschrieben.",
  "sign.signatures.entry": "{name} · {timestamp}",
  "sign.start": "Weiter zum Unterschreiben",
  "sign.step.title": "Ihre Unterschrift",
  "sign.field.name": "Name",
  "sign.field.name.error": "Bitte geben Sie Ihren Namen ein.",
  "sign.field.company": "Firma",
  "sign.field.company.hint": "Optional.",
  "sign.field.signature": "Unterschrift",
  "sign.field.signature.error": "Zeichnen Sie zuerst Ihre Unterschrift in das Feld.",
  "sign.signature.too_large": "Die Unterschrift überschreitet das Größenlimit. Löschen Sie sie und zeichnen Sie einfacher.",
  "sign.consent.label": "Ich unterschreibe diesen Frachtbrief elektronisch und stimme den eCMR-Bedingungen zu.",
  "sign.consent.error": "Bitte stimmen Sie zu, bevor Sie unterschreiben.",
  "sign.geo.label": "Meinen Standort mit dieser Unterschrift teilen",
  "sign.geo.pending": "Standort wird ermittelt…",
  "sign.geo.captured": "Standort erfasst.",
  "sign.geo.denied": "Kein Standort verfügbar. Sie können trotzdem unterschreiben.",
  "sign.submit": "Unterschreiben",
  "sign.submitting": "Wird gesendet",
  "sign.back": "Zurück zum Frachtbrief",
  "sign.success.signed_as": "Als {role} unterschrieben",
  "sign.success.consignee_note": "Der Ablieferbeleg folgt später. Für diesen Link ist nichts mehr zu tun.",
  "sign.success.no_pdf": "Es steht noch kein PDF bereit.",
  "sign.method.title": "Wie möchten Sie unterschreiben?",
  "sign.method.intro": "Sie unterschreiben diesen Frachtbrief als {role}. Wählen Sie, wie.",
  "sign.method.drawn.title": "Auf dem Bildschirm unterschreiben",
  "sign.method.drawn.body": "Zeichnen Sie Ihre Unterschrift mit dem Finger.",
  "sign.method.click_otp.title": "Mit Code bestätigen",
  "sign.method.click_otp.body": "Sie erhalten einen sechsstelligen Code und bestätigen mit einem Tippen.",
  "sign.otp.title": "Mit Code bestätigen",
  "sign.otp.intro": "Geben Sie Ihren Namen ein, stimmen Sie zu, und wir senden Ihnen einen sechsstelligen Code.",
  "sign.otp.channel.label": "Wohin soll der Code?",
  "sign.otp.channel.email": "Per E-Mail",
  "sign.otp.channel.sms": "Per SMS",
  "sign.otp.send": "Code senden",
  "sign.otp.sending": "Code wird gesendet",
  "sign.otp.code.title": "Code eingeben",
  "sign.otp.sent": "Wir haben einen Code an {destination} gesendet.",
  "sign.otp.code.label": "Sechsstelliger Code",
  "sign.otp.code.hint": "Der Code ist zehn Minuten gültig.",
  "sign.otp.code.error": "Geben Sie alle sechs Ziffern ein.",
  "sign.otp.resend": "Neuen Code senden",
  "sign.otp.resend.wait": "Neuer Code in {seconds} Sekunden",
  "sign.otp.confirm": "Bestätigen und unterschreiben",
  "sign.otp.confirming": "Wird bestätigt",
  "sign.otp.error.invalid": "Dieser Code stimmt nicht. Prüfen Sie die Nachricht und versuchen Sie es erneut.",
  "sign.otp.error.locked": "Zu viele falsche Codes. Fordern Sie in einigen Minuten einen neuen Code an.",
  "sign.otp.error.expired": "Dieser Code ist abgelaufen. Fordern Sie einen neuen an.",
  "sign.otp.error.rate_limited": "Es wurden zu viele Codes angefordert. Warten Sie einen Moment und versuchen Sie es erneut.",
  "sign.otp.error.send": "Der Code konnte nicht gesendet werden. Versuchen Sie es erneut oder unterschreiben Sie auf dem Bildschirm.",
  "sign.otp.error.unavailable": "Dieser Link hat weder E-Mail-Adresse noch Telefonnummer für einen Code. Unterschreiben Sie auf dem Bildschirm.",
  "pickup.title": "Beladen und unterschreiben",
  "pickup.intro": "Absender und Frachtführer unterschreiben diesen Frachtbrief beim Beladen gemeinsam.",
  "pickup.parties.title": "Unterschriften",
  "pickup.party.signed": "Unterschrieben von {name} am {timestamp}.",
  "pickup.party.signed_elsewhere": "Auf einem anderen Gerät unterschrieben.",
  "pickup.party.signed_name": "Unterschrieben von {name}.",
  "pickup.party.queued": "Von {name} unterschrieben, noch nicht gesendet. Das geschieht von selbst, sobald Sie wieder online sind.",
  "pickup.party.queued_stopped": "Von {name} unterschrieben, aber nicht gesendet. Sehen Sie in der Warteschlange nach.",
  "pickup.party.waiting": "Noch nicht unterschrieben.",
  "pickup.party.no_link": "Für diese Rolle wurde kein Unterschriftslink erstellt.",
  "pickup.party.link_used": "Dieser Unterschriftslink wurde bereits verwendet.",
  "pickup.party.link_expired": "Dieser Unterschriftslink ist abgelaufen.",
  "pickup.party.link_revoked": "Dieser Signaturlink wurde zurückgezogen.",
  "pickup.action.sign_here": "Hier unterschreiben",
  "pickup.action.own_device": "Auf eigenem Gerät",
  "pickup.handoff.title": "Auf eigenem Gerät: {role}",
  "pickup.handoff.body": "Lassen Sie die unterzeichnende Person diesen QR-Code scannen. Der Link funktioniert einmal und bleibt zehn Minuten gültig.",
  "pickup.handoff.qr_alt": "QR-Code zum Unterschriftslink",
  "pickup.handoff.open": "Link öffnen",
  "pickup.handoff.expires": "Gültig bis {timestamp}.",
  "pickup.handoff.waiting": "Warten auf die Unterschrift…",
  "pickup.handoff.creating": "QR-Code wird erstellt",
  "pickup.handoff.failed": "Der QR-Code konnte nicht erstellt werden.",
  "pickup.handoff.back": "Zurück zur Übersicht",
  "pickup.queued.back": "Zurück zur Übersicht",
  "pickup.done.title": "Beim Beladen abgezeichnet",
  "pickup.done.body": "Absender und Frachtführer haben beide unterschrieben.",
  "pickup.done.status": "Status der Sendung: {status}",
  "pickup.done.signature": "{role}: {name} · {timestamp}",
  "pickup.unusable.title": "Keine Beladesitzung",
  "pickup.unusable.body": "Dieser Link gehört nicht zum Beladen. Öffnen Sie den Link, den Sie vom Absender oder Frachtführer erhalten haben.",
  "delivery.title": "Ablieferung",
  "delivery.intro": "Prüfe die Packstücke, halte Vorbehalte fest und lass den Empfänger unterschreiben.",
  "delivery.step": "Schritt {current} von {total}",
  "delivery.back": "Zurück",
  "delivery.colli.title": "Packstücke prüfen",
  "delivery.colli.body": "Trage je Warenzeile ein, wie viele Packstücke du erhalten hast.",
  "delivery.colli.expected": "Erwartet: {count} {package_type}",
  "delivery.colli.received": "Erhalten",
  "delivery.colli.error": "Gib eine Zahl ab 0 ein.",
  "delivery.colli.empty": "Auf diesem Frachtbrief stehen keine Warenzeilen.",
  "delivery.colli.total": "Gesamt: {received} von {expected} Packstücken.",
  "delivery.colli.line": "{description}: {received} von {expected} erhalten.",
  "delivery.colli.match": "Die Anzahl stimmt überein.",
  "delivery.colli.shortage": "Es {count, plural, one {fehlt # Packstück} other {fehlen # Packstücke}}. Halte das als Vorbehalt fest.",
  "delivery.colli.surplus": "Es {count, plural, one {ist # Packstück} other {sind # Packstücke}} zu viel. Halte das als Vorbehalt fest.",
  "delivery.remark.title": "Vorbehalte",
  "delivery.remark.body": "Melde Schäden, eine Fehlmenge oder eine Verzögerung bei dieser Ablieferung.",
  "delivery.remark.required": "Die Anzahl weicht ab, halte deshalb einen Vorbehalt fest.",
  "delivery.remark.type": "Art des Vorbehalts",
  "delivery.remark.type.damage": "Schaden",
  "delivery.remark.type.shortage": "Fehlmenge",
  "delivery.remark.type.delay": "Verzögerung",
  "delivery.remark.type.other": "Sonstiges",
  "delivery.remark.text": "Beschreibung",
  "delivery.remark.text.hint": "Beschreibe kurz, was los ist.",
  "delivery.remark.text.error": "Beschreibe den Vorbehalt.",
  "delivery.remark.photos": "Fotos",
  "delivery.remark.photos.hint": "Höchstens {max} Fotos. Große Fotos werden vor dem Senden verkleinert.",
  "delivery.remark.photos.add": "Foto hinzufügen",
  "delivery.remark.photos.full": "Du kannst höchstens {max} Fotos mitschicken.",
  "delivery.remark.photo.alt": "Foto {number}",
  "delivery.remark.photo.compressing": "Wird verkleinert…",
  "delivery.remark.photo.uploading": "Wird gesendet… {percent}%",
  "delivery.remark.photo.stored": "Gesendet · {size}",
  "delivery.remark.photo.failed": "Senden fehlgeschlagen.",
  "delivery.remark.photo.unreadable": "Dieses Foto kann nicht gelesen werden.",
  "delivery.remark.photo.retry": "Erneut senden",
  "delivery.remark.photo.remove": "Entfernen",
  "delivery.remark.photo.waiting": "Warte, bis die Fotos gesendet sind.",
  "delivery.remark.submit": "Vorbehalt festhalten",
  "delivery.remark.submitting": "Wird festgehalten",
  "delivery.remark.skip": "Keine Vorbehalte",
  "delivery.remark.failed": "Der Vorbehalt konnte nicht festgehalten werden. Versuche es noch einmal.",
  "delivery.device.title": "Wer unterschreibt wo?",
  "delivery.device.body": "Der Empfänger unterschreibt auf deinem Gerät oder über einen QR-Code auf einem eigenen Gerät.",
  "delivery.device.driver": "Empfänger unterschreibt hier",
  "delivery.device.driver.hint": "Auf deinem Gerät. Das wird bei der Unterschrift festgehalten.",
  "delivery.device.own": "Auf eigenem Gerät",
  "delivery.device.own.hint": "Der Empfänger scannt einen QR-Code und unterschreibt auf dem eigenen Telefon.",
  "delivery.handoff.back": "Zurück zur Auswahl",
  "delivery.done.title": "Abgeliefert",
  "delivery.done.body": "Der Frachtbrief wurde bei der Ablieferung abgezeichnet.",
  "delivery.done.status": "Status der Sendung: {status}",
  "delivery.done.signed": "Unterschrieben von {name} am {timestamp}.",
  "delivery.done.signed_elsewhere": "Auf dem Gerät des Empfängers unterschrieben.",
  "delivery.done.device.driver": "Auf dem Gerät des Fahrers unterschrieben.",
  "delivery.done.device.own": "Auf dem eigenen Gerät des Empfängers unterschrieben.",
  "delivery.pod.title": "Ablieferbeleg",
  "delivery.pod.colli": "Packstücke: {received} von {expected} erhalten.",
  "delivery.pod.colli.unknown": "Packstücke: auf diesem Gerät nicht gezählt.",
  "delivery.pod.remarks.none": "Keine Vorbehalte gemeldet.",
  "delivery.pod.remark": "{type}: {text}",
  "delivery.pod.remark.untyped": "{type}",
  "delivery.pod.remark.photos": "{count, plural, one {# Foto} other {# Fotos}}",
  "delivery.pod.download": "Ablieferbeleg herunterladen",
  "delivery.pod.pdf": "Ablieferbeleg (PDF)",
  "delivery.pod.pdf.pending": "Die PDF des Ablieferbelegs ist noch nicht fertig.",
  "fixtures.title": "Komponenten",
  "fixtures.shipment": "ShipmentView",
  "fixtures.timeline": "Timeline",
  "fixtures.documents": "DocumentList",
  "fixtures.signature": "SignaturePad",
  "fixtures.signature.export": "PNG exportieren",
  "fixtures.signature.exported": "PNG mit {width}×{height} px, {bytes} Bytes.",
  "fixtures.signature.empty": "Noch nichts gezeichnet.",
  "shipment.not_provided": "Nicht ausgefüllt",
  "shipment.box": "Feld {number}",
  "shipment.goods.table": "Güter (Felder 6 bis 12)",
  "shipment.driver.hidden": "Die Kontaktdaten des Fahrers werden nicht angezeigt.",
  "shipment.driver.phone": "Telefon des Fahrers",
  "shipment.signature.method": "Methode",
  "shipment.signature.trust": "Vertrauensniveau",
  "shipment.signature.qtsp": "Vertrauensdienst",
  "shipment.signature.hash": "Versions-Hash",
  "shipment.signature.verified": "Stimmt mit der aktuellen Version überein",
  "shipment.signature.superseded": "Auf einer früheren Version unterschrieben",
  "shipment.signature.method.drawn": "Unterschrift auf dem Bildschirm",
  "shipment.signature.method.click_otp": "Bestätigung mit Einmalcode",
  "shipment.signature.method.api": "Über die API des Systems",
  "shipment.signature.method.photo_of_paper": "Foto einer Unterschrift auf Papier",
  "shipment.signature.trust.platform_auth": "Plattform-Authentifizierung",
  "shipment.signature.trust.ades": "Fortgeschritten (AdES)",
  "shipment.signature.trust.qes": "Qualifiziert (QES)",
  "inspect.title": "Frachtbrief",
  "inspect.subtitle": "Nur-Lese-Einsicht über den QR-Code auf dem Frachtbrief.",
  "inspect.version": "Version {version}",
  "inspect.viewed_at": "Angesehen am {timestamp}",
  "inspect.expires": "Dieser Kontrolllink ist gültig bis {timestamp}.",
  "inspect.integrity.ok.title": "Kette unversehrt",
  "inspect.integrity.ok.body": "{events} Ereignisse, lückenlos seit dem Anlegen.",
  "inspect.integrity.broken.title": "Kette unterbrochen",
  "inspect.integrity.broken.body": "Die Ereignisse dieser Sendung stimmen nicht mit ihrer Hash-Kette überein. Wenden Sie sich an den Frachtführer.",
  "inspect.integrity.head_hash": "Kopf-Hash",
  "inspect.documents.title": "Dokumente",
  "inspect.pdf.download": "Frachtbrief herunterladen (PDF)",
  "inspect.pdf.none": "Es steht noch kein PDF dieses Frachtbriefs bereit.",
  "inspect.print": "Drucken",
  "inspect.expired.title": "Kontrolllink abgelaufen",
  "inspect.expired.body": "Dieser Kontrolllink ist abgelaufen. Bitten Sie den Frachtführer um einen aktuellen QR-Code.",
  "inspect.rotated.title": "Kontrolllink ersetzt",
  "inspect.rotated.body": "Dieser Kontrolllink wurde ersetzt. Scannen Sie den QR-Code auf dem aktuellen Frachtbrief.",
  "inspect.not_found.title": "Unbekannter Kontrolllink",
  "inspect.not_found.body": "Prüfen Sie den QR-Code auf dem Frachtbrief.",
  "driver.title": "Als Fahrer anmelden",
  "driver.intro": "Gib die Telefonnummer ein, die dein Disponent zur Sendung hinterlegt hat. Du bekommst einen Code per SMS.",
  "driver.country.label": "Land",
  "driver.phone.label": "Telefonnummer",
  "driver.phone.hint": "Ohne Landesvorwahl; wir setzen {prefix} davor.",
  "driver.error.phone_invalid": "Das sieht nicht nach einer gültigen Telefonnummer aus.",
  "driver.button.send_code": "Code schicken",
  "driver.code.title": "Code eingeben",
  "driver.code.body": "Wir haben einen sechsstelligen Code an {phone} geschickt.",
  "driver.code.label": "Code",
  "driver.code.hint": "Sechs Ziffern, zehn Minuten gültig.",
  "driver.button.verify": "Anmelden",
  "driver.button.change_number": "Andere Nummer verwenden",
  "driver.error.code_invalid": "Dieser Code stimmt nicht oder ist abgelaufen. Fordere einen neuen an.",
  "driver.error.locked": "Zu viele Versuche. Warte ein paar Minuten und fordere dann einen neuen Code an.",
  "driver.error.session_expired": "Deine Sitzung ist abgelaufen. Melde dich erneut an.",
  "driver.list.title": "Deine Fahrten",
  "driver.sandbox.title": "Testumgebung",
  "driver.sandbox.body": "Diese Nummer steht nur auf Übungssendungen. Was du hier siehst, ist keine echte Fahrt.",
  "driver.button.sign_out": "Abmelden",
  "driver.button.refresh": "Aktualisieren",
  "driver.empty.title": "Nichts offen",
  "driver.empty.body": "Auf dieser Nummer ist gerade keine Fahrt offen. Stimmt das nicht, bitte deinen Disponenten, deine Nummer zur Sendung zu hinterlegen.",
  "driver.action.load": "Laden",
  "driver.action.deliver": "Entladen",
  "driver.reference.none": "Ohne Referenz",
  "driver.ordered_by": "Im Auftrag von {party}",
  "driver.window.none": "Kein Zeitfenster vereinbart",
  "driver.then.deliver": "Danach entladen bei {party} in {city}.",
  "driver.then.loaded": "Geladen bei {party} in {city}.",
  "driver.signed_off": "Bereits abgezeichnet.",
  "driver.button.open_pickup": "Laden und unterschreiben",
  "driver.button.open_delivery": "Abliefern und unterschreiben lassen",
  "driver.button.navigate": "Navigieren",
  "driver.tour.untitled": "Fahrt ohne Namen",
  "driver.tour.progress": "{done} von {total} Stopps",
  "driver.tour.loose": "Einzelfahrten",
  "driver.tour.stop.numbered": "Stopp {position} · {action}",
  "driver.tour.stop.done": "Abgezeichnet",
  "driver.tour.stop.waiting": "Noch nicht an der Reihe",
  "driver.tour.stop.closed": "Nicht mehr offen",
  "queue.title": "Warteschlange",
  "queue.body": "Diese Einreichungen warten auf diesem Gerät. Sie werden von selbst gesendet, sobald wieder eine Verbindung besteht.",
  "queue.badge": "{count} in der Warteschlange",
  "queue.empty.title": "Nichts in der Warteschlange",
  "queue.empty.body": "Alles, was Sie erfasst haben, wurde gesendet.",
  "queue.kind.photo": "Foto",
  "queue.kind.remark": "Vorbehalt",
  "queue.kind.signature": "Unterschrift",
  "queue.state.pending": "Wartet auf Verbindung",
  "queue.state.sending": "Wird gesendet",
  "queue.state.conflict": "Anderswo erledigt",
  "queue.state.failed": "Nicht gesendet",
  "queue.captured": "Erfasst um {timestamp}",
  "queue.hash": "Inhalts-Hash {hash}",
  "queue.attempts": "Versuche: {count}",
  "queue.reason.queue_blocked": "Nicht gesendet: eine frühere Einreichung derselben Fahrt ist hängen geblieben.",
  "queue.reason.hash_mismatch": "Nicht gesendet: der gespeicherte Inhalt stimmt nicht mit dem Hash bei der Erfassung überein.",
  "queue.reason.already_signed": "Dieser Frachtbrief wurde inzwischen auf einem anderen Gerät unterschrieben. Diese Einreichung wird nicht mehr benötigt.",
  "queue.reason.link_expired": "Der Link ist abgelaufen, bevor diese Einreichung gesendet werden konnte.",
  "queue.reason.network": "Der Server war nicht erreichbar. Sie können es erneut versuchen.",
  "queue.reason.refused": "Der Server hat diese Einreichung abgelehnt ({code}).",
  "queue.retry": "Erneut versuchen",
  "queue.discard": "Verwerfen",
  "queue.offline": "Keine Verbindung. Die Warteschlange wartet, bis Sie wieder online sind.",
  "queue.done.title": "Erfasst, noch nicht gesendet",
  "queue.done.body": "Sie haben keine Verbindung. Was Sie erfasst haben, liegt sicher auf diesem Gerät und wird von selbst gesendet, sobald Sie wieder online sind.",
  "queue.done.status": "Wird gesendet, sobald Sie online sind",
  "queue.done.open": "Warteschlange ansehen",
  "delivery.remark.photo.queued": "In der Warteschlange, wird gesendet, sobald Sie online sind",
  "sign.identification.title": "Zuerst identifizieren",
  "sign.identification.intro": "Dieser Frachtbrief verlangt {level}. Identifizieren Sie sich dafür bei {provider}; danach unterschreiben Sie wie gewohnt.",
  "sign.identification.why": "Der Vertrauensdienst stellt fest, wer Sie sind, und unterschreibt anschließend genau diese Fassung des Frachtbriefs.",
  "sign.identification.start": "Bei {provider} identifizieren",
  "sign.identification.retry": "Erneut versuchen",
  "sign.identification.waiting": "Identifizierung läuft",
  "sign.identification.waiting.body": "Wir warten darauf, dass {provider} Ihre Identifizierung bestätigt. Dieser Bildschirm geht von selbst weiter.",
  "sign.identification.level.ades": "eine fortgeschrittene Signatur (AdES)",
  "sign.identification.level.qes": "eine qualifizierte Signatur (QES)"
}
